module.exports = __webpack_public_path__ + "static/media/income_other_on.1097d496.png";